import React, { useState, useEffect } from "react";
import classes from "./SupplyHistory.module.css";
import {
  Row,
  Col,
  Form,
  Card,
  Button,
  Table,
  Tabs,
  Tab,
} from "react-bootstrap";

const SupplyHistory = (props) => {
  const [SupplyRecords, setSupplyRecords] = useState([]);
  const [Itemname, setItemname] = useState(props.Itemname);
  const [HistoryDate, setHistoryDate] = useState("");
  useEffect(() => {
    let Records = props.Records;
    setSupplyRecords(Records);
    let ThisDate = props.myDates.dates;
    if (props.myDates.type == "specific") {
      setHistoryDate(
        (
          "SUPPLY HISTORY RECORDS OF " +
          Itemname +
          " ON " +
          ThisDate
        ).toUpperCase()
      );
    } else {
      setHistoryDate(
        (
          "SUPPLY HISTORY RECORDS OF " +
          Itemname +
          " FROM " +
          ThisDate[0] +
          " TO " +
          ThisDate[ThisDate.length - 1]
        ).toUpperCase()
      );
    }
  }, []);

  return (
    <Row>
      <Col md={12} sm={12} xs={12}>
        <Row>
          <Col md={12} sm={12} xs={12}>
            <Card>
              <Card.Header>
                <Card.Header>{HistoryDate}</Card.Header>
              </Card.Header>
              <Card.Body>
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <td className={classes.tablecss}>SN</td>
                      <td className={classes.tablecss}>DATE_OF_TRANSACTION</td>
                      <td className={classes.tablecss}>DESCRIPTION</td>
                      <td className={classes.tablecss}>OPENING QUANTITY</td>
                      <td className={classes.tablecss}>BULK SUPPLIED</td>
                      <td className={classes.tablecss}>UNIT SUPPLIED</td>
                      <td className={classes.tablecss}>CLOSING QUANTITY</td>
                      <td className={classes.tablecss}>STAFF</td>
                    </tr>
                  </thead>
                  <tbody>
                    {SupplyRecords.map((SR, index) => (
                      <tr key={index} className={classes.tablerowcss}>
                        <td className={classes.tablecss}>{index + 1}</td>
                        <td className={classes.tablecss}>
                          {SR.TransactionDate}
                        </td>
                        <td className={classes.tablecss}>
                          {SR.Person === "Not Supplied"
                            ? "Quantity Edited from the Inventory"
                            : "Supply from " + SR.Person}
                        </td>
                        <td className={classes.opentablecss}>{SR.BBBefore}</td>
                        <td className={classes.tablecss}>{SR.Bulk}</td>
                        <td className={classes.tablecss}>{SR.Unit}</td>
                        <td className={classes.closetablecss}>{SR.BBAfter}</td>
                        <td className={classes.tablecss}>{SR.Staff}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SupplyHistory;
